<template>
    <div class="offcanvas_accounts">
        <h6>{{ t('frontend.my-accounts-text') }}</h6>
        <a
            v-for="(workspace, index) in workspaces"
            @click="goToWorkspace(workspace.client_portal_url)"
            :key="index"
        >
            <span>{{ workspace.company_name }}</span>
            <fa v-if="tenantStore.getTenant.client_portal_url && tenantStore.getTenant.client_portal_url.match(workspace.client_portal_url)" :icon="['fal', 'check']"></fa>
        </a>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { getAgencyWorkSpaces } from "@/api/AuthServices";
import { useTenantStore } from "@/stores/tenant";
// I18n imports
import { useI18n } from 'vue-i18n';

// use global scope
const { t, locale } = useI18n();
const props = defineProps({
    text: {
        type: String,
        default: ""
    }
});

const workspaces = ref("");
const tenantStore = useTenantStore();
// const workspaceUrl = ref(window.location.href);

onMounted(() => {
    getWorkspaces();
});

const getWorkspaces = async () => {
    try {
        const response = await getAgencyWorkSpaces();
        if (response && response.code === 200) {
            workspaces.value = response.data.tenants;
        }
    } catch (e) {
        console.log(e);
    }
};


const goToWorkspace = (url) => {
    // window.location = url + "/dashboard";
    if (tenantStore.getTenant.client_portal_url.match(url)) {
        return false;
    }
    window.location = import.meta.env.VITE_APP_HTTP_PROTOCOL + url + "/dashboard";
};
</script>

<style scoped>
.offcanvas_accounts {
    @apply px-6 py-4 bg-gray-100 border-t border-b border-gray-200 dark:bg-gray-500 dark:border-black-900;
}

.offcanvas_accounts h6 {
    @apply text-sm font-normal text-dark-200 dark:text-white mb-4;
}

.offcanvas_accounts a {
    @apply flex items-center mb-4 cursor-pointer;
}

.offcanvas_accounts span {
    @apply text-dark-200 dark:text-white font-light ltr:mr-1 rtl:ml-1;
}

.offcanvas_accounts svg {
    @apply text-green-500 text-lg;
}
</style>
